<template>
  <div class="ticket-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('ticket_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-ticket</v-icon>{{$t('ticket.tickets')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <TicketFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
            @click:row="showHandler"
@contextmenu:row="showHandlerExt"

          >
          <template slot="item.id" slot-scope="{ item }">
            <span v-if="item.priority.intensity >= 300 & item.status.finish == false">
              <v-chip
                 class="ma-2"
                 color="error"
                 text-color="white"
               >
                 {{ item['id'] }}
               </v-chip>
            </span>
            <span v-else >
              <v-chip
                 class="ma-2"
               >
                 {{ item['id'] }}
               </v-chip>
            </span>
          </template>

          <template slot="item.created" slot-scope="{ item }">
            {{ formatDateTime(item['created'], 'long') }}
          </template>
          <template slot="item.dateBug" slot-scope="{ item }">
            {{ Math.trunc((new Date() - new Date(item['dateBug']))/(1000*3600*24)) }}
          </template>
          <template slot="item.tags" slot-scope="{ item }">
            <div id="tags">
            <v-chip v-for="tag in item['tags']" :key="tag.id"
              class="ma-1 font-weight-bold"
              color="secondary"
            >
              {{ tag.name }}
            </v-chip>
          </div>
          </template>
          <template slot="item.status" slot-scope="{ item }">
            <v-chip
              class="ma-1 font-weight-bold"
              label
              :color="statuscolor(item['status'])"
            >
              <v-icon left v-if="item['status'].init">
                mdi-new-box
              </v-icon>
              <v-icon left v-if="item['status'].finish">
                mdi-flag-checkered
              </v-icon>
              <v-icon left v-if="! item['status'].finish && ! item['status'].init">
                mdi-cached
              </v-icon>
              <span v-if="language == 'fr'">{{ item['status'].namefr }}</span>
              <span v-else>{{ item['status'].name }}</span>
            </v-chip>
          </template>
            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import i18n from '../../i18n.js';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import TicketFilterForm from '../../components/ticket/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'TicketList',
  servicePrefix: 'Ticket',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    TicketFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('ticket.number'), value: 'id' },
        { text: this.$t('ticket.ticketstatus'), value: 'status' },
        { text: this.$t('qualitycheck.product.customer'), value: 'customer.name' },
        { text: this.$t('global.date'), value: 'created' },
        { text: this.$t('global.title'), value: 'name' },
        { text: this.$t('ticket.bugtype'), value: 'bugType.name' },
        { text: this.$t('contract.duration'), value: 'dateBug'},
        { text: this.$t('ticket.tags'), value: 'tags' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
      filters: {

      },
      footer: {
        'itemsPerPageText': "",
      },
      options: {sortBy : ['status.finish','created'], sortDesc : [false,true]}
    };
  },
  computed: {
    ...mapGetters('ticket', {
      items: 'list'
    }),
    ...mapFields('ticket', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    language() {
      return i18n.locale;
    }
  },
  methods: {
    ...mapActions('ticket', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    statuscolor(status) {
      if (status.important) {
        return 'error';
      }
      if (status.init) {
        return 'primary';
      }
      if (status.finish) {
        return 'success';
      }
      return 'accent';
    }
  }
};
</script>
